import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { Game } from '../../../Core'

import UIButton from '../UIButton'

/**
 * [icon description]
 * @type {Object}
 */
class AnyTestingButton extends React.Component {
  /**
   * [showAnyScreen description]
   * @return {[type]} [description]
   */
  showAnyScreen() {
    const { addScreen, clearAllPopups } = this.props
    clearAllPopups()
    addScreen('mining_screen')
  }

  /**
   * [render description]
   * @return {[type]} [description]
   */
  render() {
    const { icon, title, position } = this.props

    return (
      <UIButton
        icon={icon}
        title={title}
        position={position}
        onClick={() => this.showAnyScreen()}
      />
    )
  }
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
    clearAllPopups: bindActionCreators(Game.actions.clearAllPopups, dispatch),
  }
}

AnyTestingButton.propTypes = {
  icon: PropTypes.string,
  position: PropTypes.string,
  clearAllPopups: PropTypes.func,
  title: PropTypes.string,
  addScreen: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(AnyTestingButton)
